import React from "react";
import UpdateSettings from "./CreateEditCompanySettings";
import BaseCard from "../../../components/ui/BaseCard";
import AddEditAboutMe from "../../ProfileSettings/ProfileSetting/AddEditAboutMe";

const ClientSettings = ({ isFreelanceCompany = false, user, refetchMe }) => {
  return (
    <div className="max-h-[calc(100vh-220px)] overflow-y-auto pb-4">
      <UpdateSettings isFreelanceCompany={isFreelanceCompany} />
      {isFreelanceCompany && (
        <BaseCard className="py-2 px-4 sm:px-6 rounded-lg mt-4" elevation={1}>
          <AddEditAboutMe
            description={user?.description}
            refetchMe={refetchMe}
            isFreelanceCompanyOwner
            className="my-2"
          />
        </BaseCard>
      )}
    </div>
  );
};

export default ClientSettings;
